import axios from '../utils/request'

const GetSalespersonListApi = () => {
  return axios.get('GetSalespersonList', { })
}

const CustomerList = (cp, s, condition, value, SalespersonID) => {
  return axios.get('GetCustomerList?CurrentPage=' + cp + '&pageSize=' + s + '&condition=' + condition + '&value=' + value + '&SalespersonID=' + SalespersonID, { })
}

const CustomerList1 = (id) => {
  return axios.get('GetCustomerList1?openid=' + id, { })
}

const CustomerService = () => {
  return axios.get('GetCustomerService', { })
}

const HelpCenter = () => {
  return axios.get('GetHelpCenter', { })
}

const GetWxaCode = (loginInfo) => {
  return axios.post('GetWxaCode', {
    ...loginInfo
  })
}

const GetWxbCodeSetInfo = (ProductID) => {
  return axios.get('GetWxbCodeSetInfo?ProductID=' + ProductID, { })
}

const GetDistributionMode = () => {
  return axios.get('GetDistributionMode', { })
}

const GetProductInfo = (Value, CurrentPage, pageSize) => {
  return axios.get('GetProductInfo?Value=' + Value + '&CurrentPage=' + CurrentPage + '&pageSize=' + pageSize, {})
}

const ChangeCustomerService = (loginInfo) => {
  return axios.post('ChangeCustomerService', {
    ...loginInfo
  })
}

const ChangeHelpCenter = (loginInfo) => {
  return axios.post('ChangeHelpCenter', {
    ...loginInfo
  })
}

const ChangeCustomerList = (loginInfo) => {
  return axios.post('ChangeCustomerList', {
    ...loginInfo
  })
}

export {
  CustomerList,
  CustomerService,
  ChangeCustomerService,
  HelpCenter,
  ChangeHelpCenter,
  GetSalespersonListApi,
  ChangeCustomerList,
  CustomerList1,
  GetWxaCode,
  GetProductInfo,
  GetWxbCodeSetInfo,
  GetDistributionMode
}
